import styled from "@emotion/styled";
import { Button, Heading, Text } from "nectar-ui";

// TODO: Add Nectar types to this file
export const EmptyStateWrapper = styled.div<any>`
  ${({ theme }) => `
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: ${theme.spacings.lg};
      align-self: stretch;
  `}
`;

export const TextWrapper = styled.div<any>`
  ${({ theme, mobile }) => `
    width: ${mobile ? "296px" : "416px"};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xs};
  `}
`;

export const StyledHeading = styled(Heading)`
  letter-spacing: normal !important;
  margin: 0 !important;
  line-height: 140% !important;
`;

export const StyledText = styled(Text)`
  margin: 0 !important;
  line-height: 140% !important;
`;

export const StyledLinkButton = styled(Button)<any>`
  ${({ theme }) => `
    font-size: ${theme.typography.text.sm};
  `}
`;
